<div class="profile-menu" (click)="interceptClickEvent($event)">
  <div class="profile-menu__top">
    <div
      [tuxTooltip]="impersonatingUser ? 'Impersonating User' : undefined"
      tuxTooltipLocation="top-right"
      class="profile-menu__title"
    >
      <span>{{ user.fullname }}</span>
      <fa-icon *ngIf="impersonatingUser" [icon]="userSecretIcon"></fa-icon>
    </div>
    <div class="profile-menu__email">
      {{ user.email }}
    </div>
    <div *ngIf="user.couName" class="profile-menu__cou">
      {{ user.couName }}
    </div>
  </div>
  <div
    class="profile-menu__section"
    *ngFor="let profileMenuSection of profileData; let last = last"
  >
    <ul
      class="profile-menu__list"
      *ngFor="let profileItem of profileMenuSection"
    >
      <li>
        <ng-container *ngIf="profileItem | isNavLink">
          <a
            *ngIf="profileItem?.path?.startsWith('http'); else navRouterLink"
            [href]="profileItem.path"
            [target]="profileItem.newWindowOpen ? '_blank' : '_self'"
          >
            <ng-container *ngTemplateOutlet="navItemContent"></ng-container>
          </a>
          <ng-template #navRouterLink>
            <a
              [routerLink]="[profileItem.path]"
              [target]="profileItem.newWindowOpen ? '_blank' : '_self'"
            >
              <ng-container *ngTemplateOutlet="navItemContent"></ng-container>
            </a>
          </ng-template>
          <ng-template #navItemContent>
            <span>{{ profileItem.text }}</span>
            <fa-icon
              *ngIf="profileItem.icon"
              [icon]="profileItem.icon"
            ></fa-icon>
          </ng-template>
        </ng-container>
      </li>
    </ul>
    <hr *ngIf="!last" class="profile-menu__break" />
  </div>
</div>
